import API from '../../../../../services/api';

export const API_DASHBOARD = {
    getReadOnlyData: async () => {
        return await API.get('/dashboard/read-only').then(res => res.data);
    },
    // ----------------------- ADMIN ----------------------- //
    getAdminData: async () => {
        return await API.get('/dashboard/admin').then(res => res.data);
    },
    refreshAdminData: async () => {
        return await API.get('/dashboard/admin-refresh').then(res => res.data);
    },
    getUserMetrics: async (userId, startDate, endDate, view) => {
        const params = '?user_id= ' + userId + '&startDate=' + startDate + '&endDate=' + endDate + '&view=' + view;
        return await API.get('/dashboard/admin/user-metrics' + params).then(res => res.data);
    },
    getGeneralMetrics: async (startDate, endDate, view, clean_cache) => {
        let params = '?startDate=' + startDate + '&endDate=' + endDate + '&view=' + view;
        if(clean_cache) params += `&clean_cache=${true}`;
        return await API.get('/dashboard/admin/general-metrics' + params).then(res => res.data);
    },
    getPlataformasUserMetrics: async (plataformaId, startDate, endDate, view) => {
        const params = '?plataforma_id= ' + plataformaId + '&startDate=' + startDate + '&endDate=' + endDate + '&view=' + view;
        return await API.get('/dashboard/admin/plataformas-user-metrics' + params).then(res => res.data);
    },
    getPlataformasGeneralMetrics: async (startDate, endDate, view) => {
        const params = '?startDate=' + startDate + '&endDate=' + endDate + '&view=' + view;
        return await API.get('/dashboard/admin/plataformas-general-metrics' + params).then(res => res.data);
    },
    getDesguacesGeneralMetrics: async (startDate, endDate, view) => {
        const params = '?startDate=' + startDate + '&endDate=' + endDate + '&view=' + view;
        return await API.get('/dashboard/admin/desguaces-general-metrics' + params).then(res => res.data);
    },
    getDesguacesMetrics: async (desguaceId, startDate, endDate, view) => {
        const params = '?desguace_id= ' + desguaceId + '&startDate=' + startDate + '&endDate=' + endDate + '&view=' + view;
        return await API.get('/dashboard/admin/desguaces-metrics' + params).then(res => res.data);
    },
    getUserResume: async (startDate, endDate,) => {
        const params = '?startDate=' + startDate + '&endDate=' + endDate;
        return await API.get('/dashboard/user/resumen' + params).then(res => res.data);
    },
    getClientesMetrics: async (startDate, endDate, view) => {
        const params = '?startDate=' + startDate + '&endDate=' + endDate + '&view=' + view;
        return await API.get('/dashboard/admin/clientes-metrics' + params).then(res => res.data);
    },
    getProveedoresMetrics: async (startDate, endDate, view) => {
        const params = '?startDate=' + startDate + '&endDate=' + endDate + '&view=' + view;
        return await API.get('/dashboard/admin/proveedores-metrics' + params).then(res => res.data);
    },
    getPiezasMetrics: async (startDate, endDate, view) => {
        const params = '?startDate=' + startDate + '&endDate=' + endDate + '&view=' + view;
        return await API.get('/dashboard/admin/piezas-metrics' + params).then(res => res.data);
    },
    getIncidenciasMetrics: async (resp, startDate, endDate, view, proveedorId, tipoPiezaId, culpa) => {
        const params = '?startDate=' + startDate + '&endDate=' + endDate + '&view=' + view + 
            (resp ? ('&resp_id=' + resp) : '') + (proveedorId ? ('&proveedor_id=' + proveedorId) : '') + 
            (tipoPiezaId ? ('&tipo_pieza_id=' + tipoPiezaId) : '') + (culpa ? ('&culpa=' + culpa) : '');
    
        return await API.get('/dashboard/admin/incidencias-metrics' + params).then(res => res.data);
    },
    getStockMetrics: async (refresh) => {
        return await API.get('/dashboard/admin/stock-metrics?refresh=' + refresh).then(res => res.data);
    },
    updateStockMetrics: async (newStock) => {
        return await API.post('/dashboard/admin/update-stock-metrics', newStock).then(res => res.data);
    },
    // ----------------------- USER ----------------------- //
    getRecambistasMessages: async () => {
        return await API.get('/dashboard/user/messages').then(res => res.data);
    }
}